import { CheckBox, Delete, Edit, EditAttributesRounded, Mail, NotificationsActive, Report, Save, Search } from "@mui/icons-material";
import { Stack, Tabs, Tab, Box, ListItem, ListItemButton, List, ListItemText, Dialog, DialogTitle, DialogContent, Paper, TextField, FormControl, InputLabel, Select, MenuItem, Typography, Divider, DialogActions, Button, InputAdornment, TableContainer, TableHead, TableRow, TableCell, TableBody, Table, Checkbox, Chip, Tooltip, IconButton } from "@mui/material";
import { DataTable } from "./datatable";
import { Edituser } from "./edituser";
import { Container } from "@mui/system";
import { useState, useEffect } from "react";
import {useGlobal} from 'reactn';
import { MessageCenter } from "./messagecenter";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import '@sweetalert2/theme-material-ui/material-ui.css';
import { Bereichsauswahl } from "./utils";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import './manage.css'
import { Bescheinigungen } from "./cme";
import { NaplanFehlend } from "./naplanfehlend";
import { Outlet, Route, Routes, useLocation, useNavigate, useParams } from "react-router";
import { HuePicker, SliderPicker } from "react-color";
import { format,formatISO } from "date-fns";

const swal = withReactContent(Swal)



export function ManagePortal(){
    const [isAdmin,setIsAdmin] = useGlobal('isadmin')
    const [view,setView] = useState(0)
    const location = useLocation()
    const [userid,setUserid] = useState(false)
    const navigate = useNavigate()
    
    useEffect(() => {
        //setUserid(new URLSearchParams(location.search).get('userid'))
        if (location.pathname.includes('user')) {
            setView(2)
        }
        else if (location.pathname.includes('cme')) {
            setView(1)
        }
        else if (location.pathname.includes('messagecenter')) {
            setView(0)
        }
        else if (location.pathname.includes('appbadge')) {
            setView(4)
        }        
    },[location])

    const changeView = (u,n) => {
        setUserid(u)
        setView(n)
    }
    
    
    
    return (
        <Container maxWidth='lg' fixed className='managebox'>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={view} onChange={(e,n) => changeView(false,n)} centered>
                <Tab label='Nachrichtencenter' id={0}/>
                <Tab label='CME' id={1}/>
                <Tab label='User' id={2}/>
                <Tab label='Laufband' id={3}/>
                <Tab label='AppIconInfo' id={4}/>
                </Tabs>
            </Box>
            {view == 0 && <MessageCenter userid={userid} />}
            {view == 1 && <Bescheinigungen userid={userid} changeview={(u,n) => changeView(u,n)}/>}
            {view == 2 && <Userliste userid={userid} changeview={(u,n) => changeView(u,n)}/>}
            {view == 3 && <Marquees/>}
            {view == 4 && <AppBadge/>}
            {/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={view} onChange={(e,n) => navigate(n)} centered>
                <Tab label='Nachrichtencenter' id={'messagecenter'}/>
                <Tab label='CME' id={'cme'}/>
                <Tab label='User' id={'userliste'}/>
                <Tab label='Laufband' id={'marquee'}/>
                </Tabs>
            </Box>
            <Routes>
                <Route path="messagecenter" element={<MessageCenter userid={userid}/>}/>
                <Route path="cme" element={<Bescheinigungen userid={userid}/>}/>
                <Route path="userliste" element={<Userliste userid={userid}/>}/>
                <Route path="marquee" element={<Marquees userid={userid}/>}/>
                <Route path="*" element={<Userliste />}/>
            </Routes> */}
        </Container>
    )
}


function Userliste({useric,changeview}) {
    const [axios] = useGlobal('axios')
    const [userliste,setUserliste] = useState([])
    const [filter,setFilter] = useState('')
    const [usertoedit,setUsertoedit] = useState(false)
    const [ansicht,setAnsicht] = useState('registriert')
    const [fehlend,setFehlend] = useState([])
    const navigate = useNavigate()

    useEffect(() => {
       getuserlist()
       getfehlend()
    },[])

    const getfehlend = () => {
        axios.get('naplan_nicht_angemeldet').then(data => setFehlend(data.data))
    }

     const getuserlist = () => {
        axios.get('get_userliste').then(data => {
            console.log('userliste',data)
            setUserliste(data.data)
        })
    }

    const closeUserEditDialog = () => {
        setUsertoedit(false)
        getuserlist()
    }

    const formatDate = (datum) => {
        try {
          return format(new Date(datum),'d.M.y')
        } catch {
          return '???'
        }
    }

    const loginDate = (u) => { const d = new Date(u.lastlogin); return isNaN(d) ? null : d }

    const columns = [
        { id: 'name', label: 'Name', get: u => (u.name?.nachname || '') + ', ' + (u.name?.vorname || ''), render: u => <b>{u.name?.vorname} {u.name?.nachname}</b> },
        { id: 'email', label: 'E-Mail', get: u => u.email, hideBelow: 'sm' },
        { id: 'groups', label: 'Bereiche', get: u => (u.groups || []).join(', '), hideBelow: 'sm' },
        { id: 'lastlogin', label: 'Letztes Login', get: loginDate, render: u => formatDate(u.lastlogin), hideBelow: 'sm', nowrap: true },
        { id: 'push', label: 'Push', get: u => u.push ? 1 : 0, render: u => u.push ? <NotificationsActive fontSize='small' color='primary'/> : null, align: 'center', hideBelow: 'sm' },
        { id: 'status', label: 'Status', get: u => u.pending ? 0 : 1, render: u => u.pending ? <Chip size='small' color='error' label='freischalten'/> : null },
        { id: 'aktionen', label: '', sortable: false, align: 'right', width: 120, nowrap: true, get: u => '', render: u =>
            <Stack direction='row' justifyContent='flex-end' onClick={e => e.stopPropagation()}>
                <Tooltip title='Nachricht'><IconButton size='small' onClick={e => changeview(u._id,0)}><Mail fontSize='small'/></IconButton></Tooltip>
                <Tooltip title='CME'><IconButton size='small' onClick={e => changeview(u._id,1)}><Report fontSize='small'/></IconButton></Tooltip>
                <Tooltip title='Bearbeiten'><IconButton size='small' onClick={e => setUsertoedit(u)}><Edit fontSize='small'/></IconButton></Tooltip>
            </Stack> },
    ]

    return (
        <Container maxWidth='lg' className='ulistcontainer'>
            <Tabs value={ansicht} onChange={(e,v) => setAnsicht(v)} sx={{ mb: 1 }}>
                <Tab value='registriert' label={`Registriert (${userliste.length})`}/>
                <Tab value='fehlend' label={`Nicht im Portal (${fehlend.filter(p => !p.ignoriert).length})`}/>
            </Tabs>
            {ansicht === 'fehlend' && <NaplanFehlend rows={fehlend} reload={getfehlend}/>}
            {ansicht === 'registriert' && <DataTable columns={columns} rows={userliste} rowKey={u => u._id}
                defaultSort='status'
                searchLabel='Name, E-Mail, Handy, Bereich'
                searchFields={[u => u.name?.vorname, u => u.name?.nachname, u => u.email, u => u.mobile, u => (u.groups || []).join(' ')]}
                filters={{ options: [{value:'alle',label:'Alle'},{value:'pending',label:'freizuschalten'},{value:'aktiv',label:'aktiv'}],
                           match: (u,v) => v === 'alle' || (v === 'pending' ? !!u.pending : !u.pending) }}
                rowClass={u => u.pending ? 'pending' : ''}
                onRowClick={u => setUsertoedit(u)}
                emptyText='Keine Benutzer gefunden'/>}
            <Edituser user={usertoedit} close={e => closeUserEditDialog()} onMessage={u => changeview(u._id,0)}/>
        </Container>
    )
}

function Marquees() {
    const [axios] = useGlobal('axios')
    const [marqueeliste,setMarqueeliste] = useState([])
    const [newmarquee,setNewmarquee] = useState({text:'',active:false})


    useEffect(() => {
       getmarquees()
    },[])

     const getmarquees = () => {
        axios.get('getmarquee').then(data => {
            setMarqueeliste(data.data)
            setNewmarquee({text:'',active:false,color:'#eeff00'})
        })
    }


    const modmarquee = (m) => {
        axios.post('updatemarquee',{...m,action:'update'}).then(res => getmarquees())
    }

    const delmarquee = (m) => {
        axios.post('updatemarquee',{...m,action:'delete'}).then(res => getmarquees())
    }

    const modonestext = (t,i) => {
        let om = marqueeliste
        om[i].text = t
        setMarqueeliste(om)
    }

    return (
        <Container maxWidth='sm' className='ulistcontainer'>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>aktiv</TableCell>
                            <TableCell>Text</TableCell>
                            <TableCell>löschen</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {marqueeliste.map((m,i) => 
                            <TableRow>
                                <TableCell>
                                        <Checkbox checked={m.active} onClick={e => modmarquee({...m,active:!m.active})}/>
                                </TableCell>
                                <TableCell>
                                    <TextField value={m.text} onChange={e =>modonestext(e.target.value,i)}
                                        InputProps={{
                                            endAdornment :<InputAdornment position="end">
                                                    <Save onClick={e => modmarquee(m)}/>
                                                </InputAdornment>
                                            }}
                                    />
                                    <HuePicker onChangeComplete={(c,e) => modmarquee({...m,color:c.hex})} color={m?.color || '#eeff00'}/>
                                </TableCell>
                                <TableCell>
                                    <Delete onClick={e => delmarquee(m)}/>
                                </TableCell>
                                </TableRow>
                        )}
                        <TableRow>
                            <TableCell>
                                <Checkbox disabled/>
                            </TableCell>
                            <TableCell>
                                <TextField value={newmarquee?.text} onChange={e => setNewmarquee({...newmarquee,text:e.target.value})}
                                        InputProps={{
                                        endAdornment :<InputAdornment position="end">
                                                <Save onClick={e => modmarquee(newmarquee)}/>
                                            </InputAdornment>
                                        }}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>

            </TableContainer>
            {marqueeliste.map((m,index) => 
               <Paper key={'mar'+index}>


               </Paper>                     
            )}
        </Container>
    )
}



function AppBadge() {
    const [axios] = useGlobal('axios')
    const [lastmodified,setLastmodified] = useState('?')
    const [sending,setSending] = useState(false)
    const [infotext,setInfotext] = useState('Es gibt neue Inhalte')

    const getLastModified = () => {
        axios.get('lastbadge').then(data => {
            console.log(data)
            setLastmodified(data.data.lastupdate)
        })
    }

    const activateBadge = () => {
        setSending(true)
        axios.post('setbadge',{text:infotext}).then(res => {
            getLastModified()
            setSending(false)
        }).catch(e => setSending(false))
    }


    useEffect(() => {
        getLastModified()
    },[])



    return (
        <Container>
            <Typography variant="h6">Letzte Auslösung: {lastmodified}</Typography>
            <Divider/>
            <Container style={{marginTop:'10px',display:'flex', alignItems:'center',justifyContent:'center'}} >
                <TextField style={{marginRight:'10px'}} value={infotext} label='Infotext' helperText='darf nicht leer sein' onChange={e => setInfotext(e.target.value)}/>
                <Button disabled={sending} variant="contained" onClick={e => activateBadge()}>auslösen</Button>
            </Container>
        </Container>
    )
}